import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const DelegatedDomainDetailScene = lazy(() =>
  import("@scenes/VerifiedDomains/components/DelegatedDomainDetail").then((module) => ({
    default: module.DelegatedDomainDetailScene,
  }))
);

export const delegatedDomainDetailNRO: NavigationRoutingObject = {
  section: "settings",
  Component: DelegatedDomainDetailScene,
  heading: (t: I18nT<"dashboard-navigation">) => t("delegated-domain-detail-nro-heading", "Verified Domains"),
  pageNameForTracking: () => "Verified Domains",
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  getDeveloperNavigationAllowed: ({ hasPermission, featureOn }) => {
    if (!featureOn("verified_domain")) {
      return false;
    }
    return (
      hasPermission("company", { permission: "viewDomainSettings" }) ||
      hasPermission("company", { permission: "editDomainSettings" })
    );
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/company_settings/verified_domains/:appGroupId",
};
